import React, { useState } from "react";

import { Table, Pagination, PageLoader } from "clearsense-ui/components";
import NoData from "components/Common/NoData";

const FilesTable = ({
  columns,
  files,
  checkedRows,
  setCheckedRows,
  isLoading,
  openUploadPane,
}) => {
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  if (isLoading) {
    return <PageLoader />;
  } else if (!files?.count) {
    return (
      <NoData
        entity="files"
        actionLabel="Create File"
        onAction={openUploadPane}
      />
    );
  }

  return (
    <div className="cs-ui-table-background">
      <Table
        columnData={columns}
        rowKey={record => record.id}
        onRowSelect={(_, selectedRows) => setCheckedRows(selectedRows)}
        rowData={files.data}
        rowSelection={{
          onSelect: (_, __, selectedRows) => setCheckedRows(selectedRows),
          selectedRowKeys: checkedRows.map(row => row.id),
          onSelectAll: () =>
            checkedRows.length === files.length
              ? setCheckedRows([])
              : setCheckedRows(files.data),
        }}
        data-cy="files-table"
      />
      <Pagination
        showResultsPerPage
        totalRecordsCount={files.count}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        className="p-2 m-2"
      />
    </div>
  );
};

export default FilesTable;
